module.exports = __webpack_public_path__ + "static/media/Cap50Gb.505c7226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/Cap50Gb.svg
// module id = 125
// module chunks = 0